<template>
  <div class="container">
    <div class="row statistics">
      <div class="col-md-7 first-div">
        <Statistics />
      </div>
      <div class="col-md-5 second-div">
        <h1 class="text-center">Create Account</h1>
        <p>Please fill up the form to create an account.</p>
        <p class="mb-4 text-success" v-if="isRegistered">
          Thank you for your registration! Please wait for the confirmation
          email. Thank you!
        </p>
        <form method="POST" @submit.prevent="signUp">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-envelope"></i>
              </span>
            </div>
            <input
              type="email"
              class="form-control"
              placeholder="Email:"
              v-model.trim="$v.email.$model"
              required
            />
          </div>
          <p class="text-danger">{{ $optional(apiErrors, 'email[0]', '') }}</p>
          <p class="text-danger" v-if="!$v.email.required">
            Email is required!
          </p>
          <p class="text-danger" v-if="!$v.email.email">Email is not valid!</p>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-lock"></i>
              </span>
            </div>
            <input
              type="password"
              class="form-control"
              placeholder="Password:"
              v-model.trim="$v.password.$model"
              required
            />
          </div>
          <p class="text-danger">
            {{ $optional(apiErrors, 'password[0]', '') }}
          </p>
          <p class="text-danger" v-if="!$v.password.required">
            Password is required!
          </p>
          <p class="text-danger" v-if="!$v.password.minLength">
            Password must have at least
            {{ $v.password.$params.minLength.min }} characters!
          </p>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-lock"></i>
              </span>
            </div>
            <input
              type="password"
              class="form-control"
              placeholder="Confirm Password:"
              v-model.trim="$v.repeatPassword.$model"
              required
            />
          </div>
          <p class="text-danger" v-if="!$v.repeatPassword.sameAsPassword">
            Passwords must be identical!
          </p>
          <div class="form-group mb-2 mt-2">
            <label>Services</label>
            <multiselect
              v-model="selectedServices"
              placeholder="Search..."
              label="name"
              track-by="id"
              :options="initialServices"
              :multiple="true"
              :taggable="false"
              :max-height="150"
              :limit="4"
              :showLabels="false"
              :loading="isServicesLoading"
            ></multiselect>
          </div>
          <div class="form-group">
            <label>Communities</label>
            <multiselect
              v-model="selectedCommunities"
              placeholder="Search..."
              label="name"
              track-by="id"
              :options="initialCommunities"
              :multiple="true"
              :taggable="false"
              :max-height="150"
              :limit="4"
              :showLabels="false"
              :loading="isCommunitiesLoading"
            ></multiselect>
          </div>
          <button
            class="btn btn-primary float-right"
            type="submit"
            :disabled="$v.$anyError"
          >
            Register
            <ButtonLoader v-if="isLoading" />
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { signUp } from '../api/services/sign-up'
import { required, sameAs, minLength, email } from 'vuelidate/lib/validators'
import { formMultilSelectMixin } from '@/mixins/formMultilSelectMixin'
export default {
  mixins: [formMultilSelectMixin],
  data() {
    return {
      isLoading: false,
      isRegistered: false,
      apiErrors: {
        email: [''],
        password: ['']
      },
      password: '',
      repeatPassword: '',
      email: ''
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(8)
    },
    repeatPassword: {
      sameAsPassword: sameAs('password')
    },
    email: {
      email,
      required
    }
  },
  mounted() {
    this.getServicesList()
    this.getCommunitiesList()
  },
  methods: {
    async signUp() {
      try {
        this.form.email = this.email
        this.form.password = this.password
        this.isLoading = true
        this.isRegistered = false
        let { data } = await signUp(this.form)
        this.isRegistered = true
        this.isLoading = false
        if (data.errors) {
          this.apiErrors = data.errors
          this.isRegistered = false
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
